document.addEventListener('DOMContentLoaded', () => {
  // Manejo de carruseles/desplazamientos de ingredientes
  const sliderRows = document.querySelectorAll('.ingredient-row');
  
  sliderRows.forEach((row) => {
    const track = row.querySelector('.ingredient-items-track');
    const leftBtn = row.querySelector('.slider-prev');
    const rightBtn = row.querySelector('.slider-next');
    
    if (track && leftBtn && rightBtn) {
      leftBtn.addEventListener('click', () => {
        track.scrollBy({ left: -220, behavior: 'smooth' });
      });
      
      rightBtn.addEventListener('click', () => {
        track.scrollBy({ left: 220, behavior: 'smooth' });
      });
    }
  });

  // Mobile Menu Toggle
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const navList = document.querySelector('.header-nav-list');
  
  if (mobileToggle && navList) {
    mobileToggle.addEventListener('click', () => {
      navList.classList.toggle('mobile-open');
    });
  }
});
